import { Provider } from '@rollbar/react'

import { getRollbarConfig } from 'utils/rollbar'

import type { FC, ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export const RollbarProvider: FC<Props> = ({ children }) => (
  <Provider config={getRollbarConfig()}>{children}</Provider>
)
